export enum SurchargeDiscountTypeEnum {
    Fixed = 'fixed',
    Percent = 'percent'
}